var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.params.value)?_c('vs-chip',{staticClass:"ag-grid-cell-chip",style:(`background: ${_vm.params.value};`),attrs:{"color":_vm.chipColor(_vm.params.value)}},[_c('span',[_vm._v(_vm._s(_vm.params.value))])]):_c('span',[_vm._v("-")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }